import React from 'react';
import Svg from '../../images/ilustrations/Anye_mosquito2_new.svg';

const AnyeMosquito2 = () => (
    <img src={Svg} alt="Mosquito" style={{ width: '2em', height: '2em' }} />
);

export default AnyeMosquito2;
